import { render, staticRenderFns } from "./PopupBannerDescription.vue?vue&type=template&id=d65e69ba&scoped=true&"
import script from "./PopupBannerDescription.vue?vue&type=script&lang=ts&"
export * from "./PopupBannerDescription.vue?vue&type=script&lang=ts&"
import style0 from "./PopupBannerDescription.vue?vue&type=style&index=0&id=d65e69ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65e69ba",
  null
  
)

export default component.exports